// Central place for the deployment-specific values, so nothing is hardcoded
// in the pages. All of these are set in .env.local / Netlify env vars.

export const API_URL = (
  process.env.REACT_APP_API_URL || "http://localhost:5000"
).replace(/\/$/, "");

export const EMAILJS = {
  serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID,
  templateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
  publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
};

// Shop details, referenced from several pages.
export const SHOP = {
  name: "Optika Volyně",
  owner: "Bc. Jitka Hronková",
  ico: "02835754",
  address: "nám. Svobody 14, Volyně, 387 01",
  email: "optikavolyne@seznam.cz",
  phone: "+420604802888",
  phoneDisplay: "+420 604 802 888",
  facebook:
    "https://www.facebook.com/O%C4%8Dn%C3%AD-optika-Volyn%C4%9B-191635897936682/",
  reservio: "https://ocni-optika-bc-jitka-hronkova.reservio.com",
  mapyBadgeId: "13191595",
  coordinates: { lat: 49.166, lng: 13.88524 },
};
